<!-- template for the modal component -->
<template>
    <div :id="id" class="a11y-modal">
        <div class="a11y-modal-dialog">
            <div class="a11y-modal-content">
                <div class="a11y-modal-header">
                    <button class="a11y-modal-close a11y-modal-close-x" @click="$emit('close')"></button>
                    <div class="a11y-modal-title">
                        <slot name="h4"></slot>
                    </div>
                </div>
                <div v-if="showLoader" class="ltFormBusySpinner">
                    <div class="spin">
                        <div class="inner"></div>
                    </div>
                </div>
                <div v-else class="a11y-modal-body">
                    <slot name="body">
                        default body
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            id: {
                type: String,
                default: '',
            },
            showLoader: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
<style lang="scss">
.a11y-modal-title {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    font-weight: bold;
    unicode-bidi: isolate;
}
</style>
